$(document).on('ready turbolinks:load', function() {
  const timeout = 3000;
  const target = document.getElementById('flash_messages');
  let timer;

  if (!target) return;

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(showAlert);
  });
  const config = { attributes: false, childList: true, characterData: false };

  showAlert();
  observer.observe(target, config);

  function showAlert() {
    const $alert = $('.alert');

    clearTimeout(timer);
    $alert.animate({ opacity: 1, pointerEvents: 'auto' }, 200);
    timer = setTimeout(function () {
      $alert.animate(
        { opacity: 0, pointerEvents: 'none' },
        200,
        () => $alert.find('.close').click());
    }, timeout);
  };
});
